import React, { Component } from 'react';
import clamp from 'lodash/clamp';
import padStart from 'lodash/padStart';


export class InputTime extends Component {

  state = {
    value: '00:00',
    normalizedValue: '00:00',
  };

  input = React.createRef();

  componentDidMount(){
    this.onValuePropUpdate();
  }

  componentDidUpdate(prevProps){
    const { value } = this.props;
    if (value !== prevProps.value) {
      this.onValuePropUpdate()
    }
  }

  onValuePropUpdate = () => {
    const { value } = this.props;
    this.onValueChange(
      this.fitTimeIntoLimits(value),
    );
  };

  isValidValue = (value) => {
    return !value || /^\d{1,2}:?\d{0,2}$/.test(value);
  };

  fitTimeIntoLimits = (value) => {
    if (!value) {
      return '';
    }
    const colonSeparatedTime = this.formatTime(value);
    let [ hours = '', minutes = '' ] = colonSeparatedTime.split(':');

    if (hours && hours.length === 2) {
      const limitedHours = padStart( clamp(+hours, 0, 23) , 2, '0');
      if (minutes && minutes.length === 2) {
        minutes = padStart( clamp(+minutes, 0, 59) , 2, '0');
      }
      return limitedHours + ':' + minutes;
    }
    else {
      return colonSeparatedTime;
    }
  };

  formatTime = (value) => {
    if (/^\d{1,2}:\d{1,2}$/.test(value)) {
      return value;
    }
    else {
      return value.replace(/:/g, '').replace(/(\d{2})(\d{2})?/, '$1:$2');
    }
  };

  onInputChange = (e) => {
    const value = e.target.value;
    if (this.isValidValue(value)){
      this.onValueChange(value);
    }
  };

  onInputKeyUp = (e) => {
    let value = e.target.value;
    let cachedCursorPosition;

    if (e.key !== 'Backspace') {
      value = this.fitTimeIntoLimits(value);
    }

    if (e.key === ':' && /^\d$/.test(value)) {
      value = '0' + value + ':';
    }

    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      const delta = e.key === 'ArrowDown' ? -1 : 1;
      const [ hours = '', minutes = '' ] = value.split(':');
      cachedCursorPosition = this.input.current.selectionStart;

      if (this.input.current.selectionStart > 2) { // cursor is on minutes
        if (minutes?.length === 2) {
          let updatedMinutes = padStart( clamp(+minutes + delta, 0, 59) , 2, '0');
          value = hours + ':' + updatedMinutes;
        }
      }
      else {
        if (hours?.length === 2) {
          let updatedHours = padStart( clamp(+hours + delta, 0, 23) , 2, '0');
          value = updatedHours + ':' + minutes;
        }
      }
    }

    this.onValueChange(value, () => {
      if (typeof cachedCursorPosition !== 'undefined') {
        this.input.current.selectionStart = cachedCursorPosition;
        this.input.current.selectionEnd = cachedCursorPosition;
      }
    });
  };

  onInputKeyDown = (e) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    }
  };

  onInputBlur = (e) => {
    const [ hours = '', minutes = '' ] = this.formatTime(e.target.value).split(':');
    const normalizedValue = padStart(hours, 2, '0') + ':' + padStart(minutes, 2, '0');
    this.onValueChange(normalizedValue);
  };

  onValueChange = (newValue, callback) => {
    const { onChange } = this.props;
    if (/^\d{2}:\d{2}$/.test(newValue) && newValue !== this.state.normalizedValue) {
      onChange(newValue);
      this.setState({ normalizedValue: newValue });
    }
    if (newValue !== this.state.value) {
      this.setState({ value: newValue }, callback);
    }
  };

  render(){
    const { defaultValue, ...otherProps } = this.props;
    const { value } = this.state;

    return (
      <input {...otherProps}
        ref={this.input}
        value={value}
        onKeyUp={this.onInputKeyUp}
        onKeyDown={this.onInputKeyDown}
        onBlur={this.onInputBlur}
        onChange={this.onInputChange}/>
    );
  }
}
